import { DestroyRef, inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class ViewManagementService {
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  isEmbedded$: Observable<boolean>;

  constructor() {
    this.isEmbedded$ = this.route.queryParamMap.pipe(
      takeUntilDestroyed(this.destroyRef),
      map((params) => params.get('view') === 'embedded'),
      shareReplay(1)
    );
  }
}
